<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-4">
  <div class="flex align-items-center justify-content-between">
      <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
          {{'CAMPAIGN.AUTO_LIST' | translate}} 
          <!-- <i class="fa fa-circle-question text-xl text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i> -->
          <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" href="https://guides.unifiedfitnessplatform.ai/showcase/cluikvof40ewb4l52kb3c11aj" target="_blank">
            <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
            <span class="ml-2 hidden md:inline-block">Help Guide for {{'CAMPAIGN.AUTO_LIST' | translate}} </span>
            </a>
      </h1>
      <div class="flex justify-content-end">
          <div class="mr-2" *ngIf="false">
              <p-button icon="fa fa-table-columns" [label]="'AUTOMATION.CREATE.PRE_BUILD' | translate" styleClass="p-button-outlined text-primary surface-0 text-sm hidden md:inline-block font-bold"></p-button>
              <p-button icon="fa fa-table-columns" styleClass="p-button-outlined text-primary surface-0 md:hidden"></p-button>
          </div>
          <div (click)="createAutomation()" class="hidden md:inline-block">
              <p-button icon="fa fa-plus" [label]="'AUTOMATION.CREATE.CUSTOM_AUTOMATION' | translate" styleClass="text-sm"></p-button>
          </div>
          <div (click)="createAutomation()" class="md:hidden">
              <p-button icon="fa fa-plus"></p-button>
          </div>
      </div>
  </div>

  <!-- Banner -->
  <div *ngIf="false" class="bg-indigo-500 text-white border-round p-3 md:flex align-items-center justify-content-between my-3 text-center md:text-left">
      <strong class="block md:text-xl md:w-9">{{ 'AUTOMATION.CREATE.START_INFO' | translate }}</strong>
      <div class="md:w-3 md:text-right mt-2 md:mt-0">
          <p-button [label]="'REPORTS.REPORT_TEMPLATE.CLICK_HERE' | translate" styleClass="border-white text-white bg-transparent px-5 font-bold"></p-button>
      </div>
  </div>
  <!-- Banner -->

  <!-- Card -->

  <!-- Card Tab Header -->
  <ul class="list-none mt-3 mb-0 p-0 flex overflow-x-auto text-sm text-700 white-space-nowrap">
      <li
          [ngClass]="{'font-bold border-primary text-900': selectedOwnershipType === ownershipLevel.Tenant, 'border-white': selectedOwnershipType !== ownershipLevel.Tenant}"
          (click)="SelectOwnership(ownershipLevel.Tenant)"
          class="p-3 md:p-4 md:px-5 border-bottom-3 cursor-pointer"
      >
          {{ 'AUTOMATION.CREATE.CURRENT_TENANT' | translate }} <span class="hidden md:inline"> : {{ tenant.name_primary_language || tenant.name_secondary_language}}</span>
      </li>
      <li
          [ngClass]="{'font-bold border-primary text-900': selectedOwnershipType === ownershipLevel.Franchise, 'border-white': selectedOwnershipType !== ownershipLevel.Franchise}"
          (click)="SelectOwnership(ownershipLevel.Franchise)"
          class="p-3 md:p-4 md:px-5 border-bottom-3 cursor-pointer"
      >
          {{'AUTOMATION.CREATE.FRANCHISE' | translate}}
      </li>
      <li
          [ngClass]="{'font-bold border-primary text-900': selectedOwnershipType === ownershipLevel.Company, 'border-white': selectedOwnershipType !== ownershipLevel.Company}"
          (click)="SelectOwnership(ownershipLevel.Company)"
          class="p-3 md:p-4 md:px-5 border-bottom-3 cursor-pointer"
      >
          {{'AUTOMATION.CREATE.COMPANY' | translate}}
      </li>
  </ul>
  <!-- Card Tab Header -->

  <div class="surface-0 shadow-2 border-round">
      <div class="py-2 pl-3 pr-0 md:px-3 md:flex align-items-center justify-content-between">
          <div class="flex md:block align-items-center justify-content-between">
              <div>
                  <!-- Show skeleton while loading -->
                  <ng-container *ngIf="loading.value; else totalCount">
                      <p-skeleton width="150px" height="20px"></p-skeleton>
                  </ng-container>
                  <ng-template #totalCount>
                      <span class="text-900 font-normal text-sm white-space-nowrap mr-2" 
                            [innerHTML]="'CAMPAIGN.TOTAL_AUT_REC' | translate : {count : tableData.value.length }">
                      </span>
                  </ng-template>
              </div>
          </div>

          <div class="flex align-items-center justify-content-between pr-3">
              <div class="flex align-items-center">
                  <span class="mr-3 white-space-nowrap">{{'AUTOMATION.CREATE.FILTER_BY' | translate}}</span>
                  <p-select [options]="filters" [(ngModel)]="selectedFilter" optionLabel="name" styleClass="text-primary font-bold border-0 p-0 shadow-none" filterBy="name"
                  (onChange)="filterData($event)">
                    <ng-template pTemplate="selectedItem">
                        <div class="mt-2" *ngIf="selectedFilter">
                        <div class="text-sm block text-primary">{{ 'AUTOMATION.CREATE.'+selectedFilter.name | translate}}</div>
                        </div>
                    </ng-template>
                    <ng-template let-filter pTemplate="item">
                        <div class="text-sm">{{ 'AUTOMATION.CREATE.'+filter.name | translate }}</div>
                    </ng-template>
                    </p-select>     
                </div>

              <p-button
                  icon="fa fa-search"
                  styleClass="md:hidden p-button-outlined"
                  pStyleClass=".filter-search"
                  enterFromClass="hidden"
                  enterActiveClass="scalein"
                  leaveToClass="hidden"
                  leaveActiveClass="fadeout"
                  [hideOnOutsideClick]="true"
              ></p-button>
          </div>

          <div class="filter-search md:w-20rem mt-2 hidden md:flex pr-3 md:pr-0">
              <p-iconfield iconPosition="left">
                  <p-inputicon styleClass="fa fa-search" />
                  <input type="text" [(ngModel)]="searchText" class="text-sm" pInputText [placeholder]="'CAMPAIGN.SEARCH_AUTO' | translate" />
              </p-iconfield>
          </div>
      </div>

      <app-data-grid
          [loading]="loading.value"
          [columnData]="filteredData"
          [columns]="columns"
          [EmptyState]="emptyStateComponent$"
          [selectable]="selectAllData"
          [paginator]="false"
          (loadNextData)="fetchNextSetData($event)"
          (onAction)="onActionEvent($event)"
          [gridName]="'automation-list'"
      ></app-data-grid>
  </div>
  <!-- Card -->
</div>
<!-- Body Content-->
